export { ViewResources } from './ViewResources';
